import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import styled, { css } from 'styled-components';

const StyledBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 33%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const StyledTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${({ color }) => color || 'white'};
  font-family: MontserratBold;
  color: white;
  padding-left: 32px;
  padding-right: 32px;
  font-size: 0.6em;
`;
const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: solid;
  border-color: ${({ color }) =>
    color !== 'white' ? color : 'black' || 'black'};
  border-width: ${({ color }) =>
    color === '#3498DB' ? '5px' : '1px' || '1px'};
  padding: 16px;
`;
const StyledPackageName = styled.div`
  font-family: MontserratBold;
  font-size: 1.3em;
`;
const StyledPrice = styled.div`
  font-family: MontserratBold;
  font-size: 1.3em;
`;
const StyledAdditionalText = styled.div`
  color: rgb(184, 184, 184);
  font-size: 12px;
  font-family: MontserratRegular;
`;
const StyledPriceContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 32px;
`;
const StyledRightContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledLeftContainer = styled.div`
  display: flex;
`;
const StyledItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  ${({ isBlue }) =>
    isBlue &&
    css`
      color: #3498db;
    `}
`;
const StyledItemHeader = styled.div`
  font-family: MontserratBold;
  font-size: 1em;
`;
const StyledDescription = styled.div`
  font-family: MontserratRegular;
  font-size: 0.8em;

  span {
    font-family: MontserratBold;
  }
`;
const StyledButton = styled.div`
  font-family: MontserratBold;
  font-size: 14px;
  line-height: 24px;
  padding: 5px 20px;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
  background: linear-gradient(180deg, #ffa84d 0%, #f37217 100%);
  color: #fff;
  width: 50%;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;
const StyledButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const StyledTopContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const BasicBox3 = ({
  onChange,
  price,
  name,
  items,
  topContainer,
  selected,
  noupsto,
}) => {
  return (
    <StyledBoxContainer data-cy="package">
      {topContainer && (
        <StyledTopContainer>
          <StyledTop color={topContainer.color}>{topContainer.title}</StyledTop>
        </StyledTopContainer>
      )}
      <StyledBox color={topContainer.color}>
        <StyledPackageName>{name}</StyledPackageName>
        <StyledPriceContainer>
          <StyledPrice>${price}</StyledPrice>
          {!noupsto && (
            <StyledAdditionalText>
              &nbsp;+ Federal USPTO fees
            </StyledAdditionalText>
          )}
        </StyledPriceContainer>
        {items &&
          items.map((item, j) => (
            <StyledItem isBlue={item.isBlue} key={j}>
              <StyledLeftContainer>
                <CheckCircleOutlineIcon
                  style={{ float: 'right', marginRight: '10px' }}
                />
              </StyledLeftContainer>
              <StyledRightContainer>
                <StyledItemHeader>{item.header}</StyledItemHeader>
                <StyledDescription>{item.text}</StyledDescription>
              </StyledRightContainer>
            </StyledItem>
          ))}
        <StyledButtonContainer>
          <StyledButton
            data-cy="select-package"
            onClick={() => onChange(selected)}
          >
            Select
          </StyledButton>
        </StyledButtonContainer>
      </StyledBox>
    </StyledBoxContainer>
  );
};

export default BasicBox3;
